import './floatingbuttoncontainer.css'
export default function FloatingButtonContainer(
    {
        children,
        hasBottomNavigation = false,
        isModal = false,
        position = "right",
        className = ""
    }
) {
    return (
        <div className={`floating-button-container ${className} ${isModal ? 'fixed-position' : 'absolute-position'} ${getPosition()}`}>
            {children}
        </div>
    );

    function getPosition() {
        return hasBottomNavigation ?
            `floating-button-container-${position}-bottom-navigation` :
            `floating-button-container-${position}`;
    }
}
